// extracted by mini-css-extract-plugin
export default {"mainContainer":"Error404_mainContainer__r689K","textContainer":"Error404_textContainer__3SJA5","title":"Error404_title__j80uT","text":"Error404_text__upXYw"};